import { JsonDocument } from 'models/Blip/Index';
import { BaseRequest } from './BaseRequest';

export class ConfigurationRequest extends BaseRequest {
    Owner : string | null;
    Caller : string | null;
    Resource : JsonDocument | null;

    constructor(resource?: JsonDocument, owner?: string, caller?: string, botIdentifier?: string, clusterName?: string) {
      super();
      this.Owner = owner;
      this.Caller = caller;
      this.Resource = resource;
      this.ClusterName = clusterName;
      this.BotIdentifier = botIdentifier;
    }
}